import * as React from 'react';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth/selector';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
import logoBdspack from 'assets/logo_bdspack.png';
import logoEasyloop from 'assets/logo_easyloop.png';

import {
    TaskSolidIcon,
    MailIcon,
    ShoppingCartIcon,
    BusSolidIcon,
    ProductVariantIcon,
    MoneyIcon,
    ProductListIcon,
    ProductReleaseIcon,
    CityNext2Icon,
    ReportDocumentIcon,
    SettingsIcon,
    WorldIcon,
    CRMServicesIcon,
} from '@fluentui/react-icons';
import { getInstanceConfig } from 'utils/helper';
import { NavItem } from './NavItem/NavItem';

import styles from './NavigationBar.module.scss';

export const NavigationBar: React.FC = () => {
    const auth = useSelector(authSelector);
    const location = useLocation();

    const instanceConfig = getInstanceConfig();

    return (
        <div
            className={classnames(styles.navigationLayout, styles.container)}
            style={{
                backgroundColor: instanceConfig.navBackgroundColor,
            }}
        >
            <div>
                <img
                    src={instanceConfig.instance === 'easyloop' ? logoEasyloop : logoBdspack}
                    alt="Logo"
                    className={instanceConfig.instance === 'easyloop' ? styles.logoEasyloop : styles.logoBdspack}
                />
                {auth.isAuthenticated && (
                    <>
                        <NavItem
                            active={location.pathname.startsWith('/taetigkeiten')}
                            icon={TaskSolidIcon}
                            label="Meine Tätigkeiten"
                            to="/taetigkeiten"
                        />
                        {/* (auth.rolle === 'ID' || auth.rolle === 'GF') && (
                            <NavItem
                                active={location.pathname.startsWith('/wiedervorlagen')}
                                icon={RepeatAllIcon}
                                label="Wieder-vorlagen"
                                to="/wiedervorlagen"
                            />
                        ) */}
                        <NavItem
                            active={location.pathname.startsWith('/kunden')}
                            icon={CityNext2Icon}
                            label="Kunden & Lieferanten"
                            to="/kunden"
                        />
                        <NavItem
                            active={location.pathname.startsWith('/angebote')}
                            icon={ProductReleaseIcon}
                            label="Angebote"
                            to="/angebote"
                        />
                        {(auth.rolle === 'ID' || auth.rolle === 'GF') && (
                            <NavItem
                                active={location.pathname.startsWith('/services')}
                                icon={CRMServicesIcon}
                                label="Services"
                                to="/services"
                            />
                        )}
                        <NavItem
                            active={location.pathname.startsWith('/auftraege')}
                            icon={ProductListIcon}
                            label="Aufträge"
                            to="/auftraege"
                        />
                        {(auth.rolle === 'ID' || auth.rolle === 'GF') && (
                            <NavItem
                                active={location.pathname.startsWith('/bestellungen')}
                                icon={ShoppingCartIcon}
                                label="Bestellungen"
                                to="/bestellungen"
                            />
                        )}

                        <NavItem
                            active={location.pathname.startsWith('/lieferungen')}
                            icon={BusSolidIcon}
                            label="Lieferungen"
                            to="/lieferungen"
                        />
                        <NavItem
                            active={location.pathname.startsWith('/rechnungen')}
                            icon={MoneyIcon}
                            label="Rechnungen"
                            to="/rechnungen"
                        />

                        {(auth.rolle === 'ID' || auth.rolle === 'GF') && (
                            <NavItem
                                active={location.pathname.startsWith('/lieferantenrechnungen')}
                                icon={MoneyIcon}
                                label="Liefer.Rechn."
                                to="/lieferantenrechnungen"
                            />
                        )}
                        <NavItem
                            active={location.pathname.startsWith('/lager')}
                            icon={ProductVariantIcon}
                            label="Lager"
                            to="/lager"
                        />
                        <NavItem
                            active={location.pathname.startsWith('/karte')}
                            icon={WorldIcon}
                            label="Karte"
                            to="/karte"
                        />
                        {(auth.rolle === 'ID' || auth.rolle === 'GF') && (
                            <NavItem
                                active={location.pathname.startsWith('/mailing')}
                                icon={MailIcon}
                                label="Mailing"
                                to="/mailing"
                            />
                        )}
                        <NavItem
                            active={location.pathname.startsWith('/berichte')}
                            icon={ReportDocumentIcon}
                            label="Berichte"
                            to="/berichte"
                        />
                        {(auth.rolle === 'ID' || auth.rolle === 'GF') && (
                            <NavItem
                                active={location.pathname.startsWith('/extras')}
                                icon={SettingsIcon}
                                label="Extras"
                                to="/extras"
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
